import { ButtonGroup, useNavigation } from '@subaio/components'

import { asContainer } from 'lib/container'

import { ButtonOutline } from 'components/Buttons'
import { HeaderIconNotFound } from 'components/Icons'
import { SplashScreen } from 'components/Layout'

export const container = asContainer<{}>()({
	authentication: { type: 'public' },
	Running: () => {
		const { onNavigateTo } = useNavigation()
		return (
			<SplashScreen title="We couldn't find what you were looking for" icon={<HeaderIconNotFound />}>
				<ButtonGroup spaced>
					<ButtonOutline label='Go back' onClick={() => onNavigateTo({ name: 'Home' })} />
				</ButtonGroup>
			</SplashScreen>
		)
	},
})
